import { Configuration, ConfigurationInput } from './types';
import { routeConstants, UserProfileSectionType } from 'app/routes/route-constants';
import { UserProfileTranslation } from 'app/area/user-profile/constants';
import { getNotificationsApiUrl } from 'app/infrastructure/hosting';

export const configuration = (input: ConfigurationInput): Configuration[] => [
  {
    section: UserProfileSectionType.Settings,
    visible: true,
    iconUrl: '/i/case-sections/default.svg',
    url: routeConstants.userProfileActiveSection(UserProfileSectionType.Settings),
    label: (translation: UserProfileTranslation) => translation.settings_text
  },
  {
    section: UserProfileSectionType.DefaultValues,
    visible: true,
    iconUrl: '/i/case-sections/where-and-what.svg',
    url: routeConstants.userProfileActiveSection(UserProfileSectionType.DefaultValues),
    label: (translation: UserProfileTranslation) => translation.default_values_text
  },
  {
    section: UserProfileSectionType.Subscriptions,
    visible: input.showSubscriptions,
    iconUrl: '/i/case-sections/email.svg',
    url: routeConstants.userProfileActiveSection(UserProfileSectionType.Subscriptions),
    label: (translation: UserProfileTranslation) => translation.subscriptions
  },
  {
    section: UserProfileSectionType.Notifications,
    visible: !!getNotificationsApiUrl() && input.showNotificationChannelsInfo,
    url: routeConstants.userProfileActiveSection(UserProfileSectionType.Notifications),
    iconUrl: '/i/case-sections/bell.svg',
    label: (translation: UserProfileTranslation) => translation.notifications_text
  }
];
